import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { authApi, useSessionStore } from '@/entities/user';
import type { Credentials, RegistrationDetails } from '@/entities/user';
import { setAccessToken } from '@/shared/api';

export function useAuthActions() {
  const setSession = useSessionStore((state) => state.setSession);
  const clear = useSessionStore((state) => state.clear);
  const queryClient = useQueryClient();

  const login = useCallback(
    async (credentials: Credentials) => {
      const response = await authApi.login(credentials);
      setSession(response.user);
    },
    [setSession],
  );

  const register = useCallback(
    async (details: RegistrationDetails) => {
      const response = await authApi.register(details);
      setSession(response.user);
    },
    [setSession],
  );

  const logout = useCallback(async () => {
    await authApi.logout();
    setAccessToken(null);
    clear();
    // Cached lists may contain data the anonymous user should not keep seeing.
    queryClient.clear();
  }, [clear, queryClient]);

  return { login, register, logout };
}
